import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    // NOTE: You can define the basic palette of the application here
  }
});

export default theme;
